import { EnumButtonName } from '@calm/evexia-analytics';
import { useAudio } from '@rhg/hooks/use-audio';
import playerMessages from '@rhg/lang/messages/player';
import {
    IconButton,
    IconButtonProps,
    SxProps,
    Theme,
} from '@rhg/libs/material';
import {
    ClosedCaptionFilled,
    ClosedCaptionOutline,
} from '@rhg/libs/material/icons';
import { useIntl } from 'react-intl';

export interface CcButtonProps {
    sx?: SxProps<Theme>;
    size?: IconButtonProps['size'];
    variant?: IconButtonProps['variant'];
}

export function CcButton({ sx, size, variant }: CcButtonProps) {
    const { formatMessage } = useIntl();
    const {
        controls: { isShowingSubtitles, hasSubtitles, toggleSubtitles },
    } = useAudio();

    // Hide entirely when the track has no caption track. A permanently disabled
    // CC button reads as broken; absence is clearer.
    if (!hasSubtitles) {
        return null;
    }

    const icon = isShowingSubtitles ? (
        <ClosedCaptionFilled color="info" />
    ) : (
        <ClosedCaptionOutline color="inherit" />
    );

    return (
        <IconButton
            trackButton={EnumButtonName.Subtitles}
            trackProps={{ IsCCEnabled: !isShowingSubtitles }}
            onClick={() => toggleSubtitles()}
            aria-label={
                isShowingSubtitles
                    ? formatMessage(playerMessages['player.disable_cc'])
                    : formatMessage(playerMessages['player.enable_cc'])
            }
            size={size}
            variant={variant}
            sx={sx}
        >
            {icon}
        </IconButton>
    );
}
